/*LIBRARY*/
import React, { useState, useContext } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import { set_value_project } from "../../App/actions/projectActions";

/*PICTURE*/
import ICON_PLUS from "../../Assets/jsx/ICON_PLUS";
import ICON_BOX from "../../Assets/jsx/ICON_BOX";
import ICON_LIST from "../../Assets/jsx/ICON_LIST";
import ICON_ARROW_DOWN from "../../Assets/jsx/ICON_ARROW_DOWN";
import ICON_ARROW_UP from "../../Assets/jsx/ICON_ARROW_UP";
import ICON_EXPAND from "../../Assets/jsx/ICON_EXPAND";

/*FUNCTION*/
import dict from "../../Data/dict.json";
import sort_array from "../../App/validation/sort_array";
import { ErrorContext } from "../../Debug/ErrorHandler/ErrorContext";

/*DATA*/

/*CONST*/

const BI_CONTROL_PANEL = ({
  auth,
  project,
  set_value_project,
  toggle_create_bi,
}) => {
  const [modal_menu, set_modal_menu] = useState(false);
  const [anchor, set_anchor] = useState(null);
  const { handleError } = useContext(ErrorContext);

  const {
    is_sort_from_small,
    geo_project_list,
    geo_project_list_child,
    folder_project_list,
    folder_project_child_list,
    folder_object_selected_list,
  } = project;

  const on_change_localstorage = (name, value) => {
    handleError(() => {
      set_modal_menu(false);
      localStorage?.setItem(name, value);
      set_value_project({ key: name, value: value });

      if (name === "mode_sort") {
        /*
        folder
        
        name - name
        date_created - date_created
        date_modified - date

        project

        name - name
        date_created - date_created
        date_modified - date_modified
        */
        let key_project = value;
        let key_folder = value;
        if (value === "date_modified") {
          key_project = "date";
        }

        if (
          !folder_object_selected_list ||
          folder_object_selected_list.length === 0
        ) {
          const sorted_geo = sort_array(
            geo_project_list,
            key_project,
            is_sort_from_small,
          );
          const sorted_folder = sort_array(
            folder_project_list,
            key_folder,
            is_sort_from_small,
          );

          set_value_project({
            key: "geo_project_list",
            value: sorted_geo,
          });
          set_value_project({
            key: "folder_project_list",
            value: sorted_folder,
          });
        } else {
          const sorted_geo_child = sort_array(
            geo_project_list_child,
            key_project,
            is_sort_from_small,
          );
          const sorted_folder_child = sort_array(
            folder_project_child_list,
            key_folder,
            is_sort_from_small,
          );

          set_value_project({
            key: "geo_project_list_child",
            value: sorted_geo_child,
          });
          set_value_project({
            key: "folder_project_child_list",
            value: sorted_folder_child,
          });
        }
      }
    })();
  };

  const toggle_localstorage = (name) => {
    handleError(() => {
      const value = project[name];
      const new_value = !value;
      localStorage?.setItem(name, new_value);
      set_value_project({ key: name, value: new_value });

      const mode_sort = localStorage?.getItem("mode_sort") || "date_created";
      on_change_localstorage("mode_sort", mode_sort);
    })();
  };

  const toggle_menu = (event) => {
    handleError(() => {
      if (event?.currentTarget) {
        set_anchor(event.currentTarget);
        set_modal_menu(true);
      } else {
        set_anchor(null);
        set_modal_menu(false);
      }
    })();
  };

  // local storage
  const language = localStorage?.language || auth.language;

  const mode_view = localStorage?.getItem("mode_view") || "box"; //box || list
  const mode_sort = localStorage?.getItem("mode_sort") || "date_modified"; //name || date_created || date_modified

  // content
  const mode_sort_list = [
    {
      key: "name",
      name: dict?.["Name"]?.[language],
    },
    {
      key: "date_created",
      name: dict?.["Date created"]?.[language],
    },
    {
      key: "date_modified",
      name: dict?.["Date modified"]?.[language],
    },
  ];

  const mode_sort_name = mode_sort_list?.find(
    (item) => item?.key === mode_sort,
  )?.name;

  const modal_menu_content = (
    <FLOAT_MENU
      id="basic-menu"
      anchorEl={anchor}
      open={modal_menu}
      onClose={() => toggle_menu()}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      style={{ borderRadius: "15px" }}
    >
      <div>
        {mode_sort_list?.map((item) => {
          return (
            <div key={item?.key}>
              <button
                onClick={() => on_change_localstorage("mode_sort", item?.key)}
                className={`button_small margin_bottom ${
                  mode_sort === item?.key
                    ? "background_black"
                    : "background_grey"
                }`}
              >
                {item?.name}
              </button>
              <br />
            </div>
          );
        })}
      </div>
    </FLOAT_MENU>
  );

  return (
    <main>
      {modal_menu_content}

      {/* Main Flex Container replacing the outer table */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          width: "100%",
          flexWrap: "wrap",
        }}
      >
        {/* Left Section */}
        <div
          style={{
            flex: "1 1 auto",
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <main
            className="margin_bottom"
            style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}
          >
            <button
              type="button"
              onClick={toggle_create_bi}
              className="button_pill background_white margin_bottom margin_right"
              data-mapid="clickBIDashboard"
            >
              <span className="badge_circle background_black">
                <ICON_PLUS />
              </span>{" "}
              {dict?.["New BI Dasboard"]?.[language] || "New BI Dashboard"}
            </button>
          </main>
        </div>

        {/* Right Section */}
        <div
          style={{
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          {/* View Mode Buttons */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-end",
            }}
          >
            <button
              type="button"
              className={`button margin_bottom margin_right ${
                mode_view === "box" ? "background_black" : "background_white"
              }`}
              onClick={() => on_change_localstorage("mode_view", "box")}
            >
              <ICON_BOX
                className={
                  mode_view === "box" ? "background_black" : "background_white"
                }
              />
            </button>
            <button
              type="button"
              className={`button margin_bottom margin_right ${
                mode_view === "list" ? "background_black" : "background_white"
              }`}
              onClick={() => on_change_localstorage("mode_view", "list")}
            >
              <ICON_LIST
                className={
                  mode_view === "list" ? "background_black" : "background_white"
                }
              />
            </button>
          </div>

          <section
            className="button_pill background_white margin_bottom margin_right"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                minWidth: "160px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <button
                  className="badge_circle background_grey margin_right"
                  onClick={() => toggle_localstorage("is_sort_from_small")}
                  data-mapid="clickShortArrow"
                  style={{ cursor: "pointer" }}
                >
                  {!is_sort_from_small ? (
                    <ICON_ARROW_DOWN />
                  ) : (
                    <ICON_ARROW_UP />
                  )}
                </button>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  onClick={toggle_menu}
                  className="inline_center"
                  data-mapid="clickShort"
                  style={{ cursor: "pointer" }}
                >
                  {mode_sort_name} <ICON_EXPAND />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
});

export default connect(mapStateToProps, { set_value_project })(
  BI_CONTROL_PANEL,
);
